var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5875 11.3331L4.08754 3.08312C3.95821 3.01844 3.81295 2.99253 3.66924 3.00849C3.52554 3.02446 3.38951 3.08163 3.27754 3.17312C3.1706 3.26273 3.09079 3.3804 3.04707 3.5129C3.00334 3.64539 2.99745 3.78745 3.03004 3.92312L5.25004 12.0006L3.00004 20.0556C2.96946 20.1689 2.96589 20.2878 2.98961 20.4027C3.01334 20.5176 3.06371 20.6254 3.13665 20.7173C3.2096 20.8092 3.3031 20.8827 3.40964 20.9319C3.51617 20.9811 3.63276 21.0047 3.75004 21.0006C3.86744 20.9999 3.98304 20.9717 4.08754 20.9181L20.5875 12.6681C20.7104 12.6052 20.8135 12.5096 20.8855 12.3918C20.9575 12.274 20.9956 12.1386 20.9956 12.0006C20.9956 11.8626 20.9575 11.7272 20.8855 11.6094C20.8135 11.4917 20.7104 11.3961 20.5875 11.3331ZM4.91254 18.8331L6.57004 12.7506H13.5V11.2506H6.57004L4.91254 5.16811L18.57 12.0006L4.91254 18.8331Z",
    fill: "#5D6679"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendNotification);
export default __webpack_public_path__ + "static/media/SendNotification.6a13f35155cf57278fdd95a7406347d5.svg";
export { ForwardRef as ReactComponent };